import { render } from "./TabsBar.vue?vue&type=template&id=1a6fab7d"
import script from "./TabsBar.vue?vue&type=script&lang=js"
export * from "./TabsBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__